import React from "react";
import PropTypes from "prop-types";
import { SVG_Business } from "svg/SVGs";
import { useTranslation } from "react-i18next";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";

const AddStoreModel = (props) => {
  const { t } = useTranslation();
  const footer = (
    <div className="flex justify-center">
      <AppButton onClick={props.onClose} size="lg" className="min-w-36">
        {t("Create Store")}
      </AppButton>
    </div>
  );

  return (
    <AppModal open={props.open} onClose={props.onClose}  closable={false} width={520} footer={footer}>
      <div className="text-center p-5 flex-auto justify-center">
          <SVG_Business />
          <h2 className="text-xl font-bold py-4 ">{t("Create Store")}</h2>
          <p className="text-sm text-gray-500 px-8">
            {t("Please Add Store to get the full user experiences")}
          </p>
      </div>
    </AppModal>
  );
};

AddStoreModel.propTypes = {
  handleValues: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
export default AddStoreModel;
